import { cn } from '@/lib/cn';

/**
 * Compact Yes/No selector for profile questions. `null` means unanswered
 * (neither option selected). Selecting an option calls `onChange`.
 */
export function YesNo({
  value,
  onChange,
  label,
  disabled,
}: {
  value: boolean | null;
  onChange: (value: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <div className="flex gap-2" role="group" aria-label={label}>
      <Choice
        selected={value === true}
        disabled={disabled}
        onClick={() => onChange(true)}
      >
        Yes
      </Choice>
      <Choice
        selected={value === false}
        disabled={disabled}
        onClick={() => onChange(false)}
      >
        No
      </Choice>
    </div>
  );
}

function Choice({
  selected,
  disabled,
  onClick,
  children,
}: {
  selected: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
      className={cn(
        'inline-flex h-8 min-w-14 items-center justify-center rounded-md border px-4 text-xs font-medium transition-colors disabled:opacity-50',
        selected
          ? 'border-accent bg-accent text-white'
          : 'border-border bg-surface text-text-secondary hover:border-text-secondary',
      )}
    >
      {children}
    </button>
  );
}
